import { Avatar, useTheme } from '@mui/material';
import { FC } from 'react';
import { lightNeutral, lightPrimary } from 'src/colors';

interface Props {
  avatarText: string;
}

export const AccountPopoverAvatar: FC<Props> = ({ avatarText }) => {
  const {
    palette: { mode },
  } = useTheme();

  return (
    <Avatar
      sx={{
        width: '40px',
        height: '40px',
        backgroundColor: mode === 'light' ? lightNeutral[100] : '#2A1803',
        border: `1px solid ${
          mode === 'light' ? lightPrimary.borders : '#E48D22'
        }`,
        fontSize: '14px',
        fontWeight: '400',
        color: 'text.primary',
        borderRadius: '100px',
      }}
      variant="rounded">
      {avatarText}
    </Avatar>
  );
};
